import "./TopSubNavBar.css";

const TopSubNavBar = ({ topTab, subTab, selectSubTab, tabList }) => {
  const activeTab = tabList.find((tab) => tab.name === topTab);
  const subTabList = activeTab?.subTabList ?? [];

  // 하위 메뉴가 없는 상단 메뉴에서는 줄 자체를 두지 않는다(밑줄만 남으면 어색하다).
  if (subTabList.length === 0) {
    return null;
  }

  return (
    <div className="teacher-sub-nav">
      <div className="teacher-sub-nav__inner">
        {subTabList.map((subTabItem) => (
          <span
            key={subTabItem.name}
            className={`teacher-sub-nav__tab${
              subTab === subTabItem.name ? " teacher-sub-nav__tab--active" : ""
            }`}
            onClick={() => selectSubTab(subTabItem.name)}
          >
            {subTabItem.badge ? (
              // 배지는 글 대신 이름 오른쪽 위 작은 별 하나(2026-10-20 대표: 글을 붙이면 탭이 길어진다)
              <span className="teacher-sub-nav__starred">
                {subTabItem.text}
                <span className="teacher-sub-nav__star" aria-label={subTabItem.badge}>✦</span>
              </span>
            ) : (
              subTabItem.text
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TopSubNavBar;
